(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcc-dish-portal"] && !Shopify.designMode) return;
  try {
    (function(){
  var portal = document.getElementById('tcc-portal');
  if (!portal) return;
  var MAX = parseInt(portal.dataset.max, 10) || 5;
  var IS_SUBSCRIBER = portal.dataset.subscriber === 'true';
  var selected = new Map();
  var selectedSides = new Map();

  // v5: migrated backend from Google Apps Script to a Cloudflare Worker
  // (Google Workspace suspension took down the old backend entirely —
  // see 05-open-items.md "De-Google-ify Backend"). KEEP THIS IN SYNC
  // with assets/kitchen.js's WORKER_URL — same underlying Worker.
  var WORKER_URL = 'https://tcc-kitchen-worker.long-rice-fd6e.workers.dev';

  // v9: SELF-HEAL STALE CART ATTRIBUTES. Confirming dishes writes note +
  // attributes (meal_selections, selection_week, etc.) directly onto the
  // Shopify CART via /cart/update.js. If a customer confirms dishes one
  // week but doesn't actually complete a real checkout until a LATER,
  // unrelated week (Shopify carts persist ~14 days), those stale
  // attributes ride along into whatever order eventually gets placed —
  // confirmed on order #3311, which showed a selection_week more than a
  // week older than the order itself. On every portal load, check the
  // cart's own selection_week attribute and wipe it (and the related
  // attributes/note) if it's more than 8 days old, so a delayed checkout
  // can't drag forward a stale confirmation summary.
  function tccClearStaleCartAttrsIfNeeded_() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        var attrs = cart.attributes || {};
        var sw = attrs.selection_week;
        if (!sw) return;
        var ageDays = (new Date() - new Date(sw + 'T00:00:00')) / 86400000;
        if (ageDays > 8) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              note: '',
              attributes: { meal_selections: '', selection_week: '', chefs_choice_fallback: '', bonus_dish_selection: '', sides_selected: '' }
            })
          }).then(function(){ console.log('[TCC] Cleared stale cart attributes from', sw); });
        }
      })
      .catch(function(err) { console.warn('[TCC] Could not check/clear stale cart attributes:', err); });
  }
  tccClearStaleCartAttrsIfNeeded_();

  // v9: LOCK PORTAL IF ALREADY CONFIRMED THIS WEEK. Previously a subscriber
  // could reopen this page any time before Thursday's cutoff and resubmit
  // a completely different set of dishes with no indication anything had
  // already been saved. On load, ask the Worker (new read-only endpoint)
  // whether a confirmation already exists for THIS week (same week_of key
  // the backend already uses for renewals); if so, replace the
  // interactive selection area with a locked summary instead.
  //
  // v14: this ALSO now handles the post-cutoff window. Between Friday 8PM
  // and Sunday 11PM ET picking is closed for everyone, so the banner is
  // rendered immediately from the ET clock (no wait on the network, no
  // flash of an open grid) and then filled in with either the subscriber's
  // own picks or the Chef's Choice message once the status call returns.
  function tccCheckExistingConfirmation_() {
    var email = portal.dataset.customerEmail;
    if (TCC_PICKING_LOCKED) tccRenderCutoffBanner_({ phase: 'checking' });
    if (!email) return;
    var weekOf = tccWeekOfMonday_();
    fetch(WORKER_URL + '/api/portal/status?email=' + encodeURIComponent(email) + '&week_of=' + encodeURIComponent(weekOf))
      .then(function(r){ return r.json(); })
      .then(function(res) {
        var confirmed = !!(res && res.status === 'ok' && res.confirmed);
        if (TCC_PICKING_LOCKED) {
          tccRenderCutoffBanner_({
            phase: confirmed ? 'confirmed' : 'chefs',
            meals: (res && res.meals) || [],
            bonusDish: (res && res.bonus_dish) || '',
            customerNote: (res && res.customer_note) || '',
            sides: (res && res.sides) || null
          });
          return;
        }
        if (confirmed) {
          tccRenderLockedState_(res.meals || [], res.bonus_dish || '', res.customer_note || '', res.sides || null);
        }
      })
      .catch(function(err) {
        // Fails open OUTSIDE the cutoff window — if the status check itself
        // fails, the customer can still use the normal selection flow rather
        // than being blocked. INSIDE the window it fails to a neutral message
        // rather than to "Chef's Choice", because we cannot tell from here
        // whether they confirmed, and wrongly telling someone their own picks
        // were discarded is worse than saying nothing.
        console.warn('[TCC] Could not check existing confirmation:', err);
        if (TCC_PICKING_LOCKED) tccRenderCutoffBanner_({ phase: 'unknown' });
      });
  }

  // The interactive selection area, hidden whenever the portal is locked —
  // either because this subscriber already confirmed, or because the Friday
  // 8PM cutoff has passed. Shared by both lock paths so the two can never
  // drift apart and leave one section visible in only one of them.
  var TCC_INTERACTIVE_SELECTORS = ['.tcc-progress-section', '.tcc-filters', '#tcc-grid', '#tcc-bonus-portal', '#tcc-sides-section', '#tcc-notes-section', '.tcc-chefs-row', '.tcc-confirm-row'];

  function tccHideInteractive_() {
    TCC_INTERACTIVE_SELECTORS.forEach(function(sel) {
      var el = portal.querySelector(sel);
      if (el && el.style.display !== 'none') el.style.display = 'none';
    });
  }

  // v15: one renderer for the sides state, used by the fresh-confirm success
  // card and by the locked card on reload. Returns HTML (may be '').
  //   Awaiting Payment -> a single "Pay $X for your sides" button
  //   Paid / Applied   -> the sides listed as confirmed
  //   anything else    -> nothing
  function tccSidesStateHtml_(sides) {
    if (!sides || !sides.status) return '';
    var items = (sides.items || []).map(function(i){ return (i.title || '') + ' \u00d7 ' + (i.quantity || 1); }).join(', ');
    var st = String(sides.status).toLowerCase();
    if (st === 'awaiting payment' && sides.pay_url) {
      var amt = sides.total ? ' $' + parseFloat(sides.total).toFixed(2) : '';
      return '<div class="tcc-sides-pay">' +
        '<strong>&#127858; One more step \u2014 pay for your sides</strong>' +
        (items ? '<p class="tcc-sides-pay__items">' + items.replace(/</g,'&lt;') + '</p>' : '') +
        '<p>Your dishes are saved. Your sides are added to this week\'s delivery as soon as payment goes through \u2014 no delivery fee, secure Shopify checkout.</p>' +
        '<a class="tcc-sides-pay__btn" href="' + sides.pay_url + '" target="_blank" rel="noopener">Pay' + amt + ' for sides &#8594;</a>' +
        '</div>';
    }
    if (st === 'paid' || st === 'applied') {
      return '<div class="tcc-success__tags" style="margin-top:8px">' +
        (sides.items || []).map(function(i){ return '<span class="tcc-success__tag" style="border-color:#7C9CBF;color:#2C5282;">&#127858; ' + (i.title || '').replace(/</g,'&lt;') + ' \u00d7 ' + (i.quantity || 1) + ' \u2014 paid</span>'; }).join('') +
        '</div>';
    }
    return '';
  }

  function tccRenderLockedState_(meals, bonusDish, customerNote, sides) {
    if (document.getElementById('tcc-locked-banner')) return;
    tccHideInteractive_();

    var tags = meals.map(function(n){ return '<span class="tcc-success__tag">&#10003; ' + n + '</span>'; });
    if (bonusDish) tags.push('<span class="tcc-success__tag" style="border-color:#C9A24B;color:#8B5E10;">&#127873; Bonus: ' + bonusDish + '</span>');

    var banner = document.createElement('div');
    banner.id = 'tcc-locked-banner';
    banner.className = 'tcc-success';
    banner.innerHTML =
      '<div class="tcc-success__icon">&#9989;</div>' +
      '<div class="tcc-success__content">' +
        '<strong>You\'re all set for this week!</strong>' +
        '<p>Your dishes are already confirmed below. Need to change something? WhatsApp us before Thursday 11PM and we\'ll update it for you.</p>' +
        '<div class="tcc-success__tags">' + tags.join('') + '</div>' +
        (customerNote ? '<p style="margin-top:8px;font-size:.76rem;color:#3A7A5A">&#128221; Your note: ' + customerNote.replace(/</g,'&lt;') + '</p>' : '') +
        tccSidesStateHtml_(sides) +
        '<div id="tcc-portal-push-nudge"></div>' +
      '</div>';

    var progressSection = portal.querySelector('.tcc-progress-section');
    if (progressSection && progressSection.parentNode) {
      progressSection.parentNode.insertBefore(banner, progressSection);
    }
    tccMaybeShowPushNudge_('tcc-portal-push-nudge');
  }

  // v14: the post-cutoff card. Rendered between Friday 8PM and Sunday 11PM ET.
  // Four phases:
  //   checking  — drawn synchronously on load so there is no flash of an open
  //               grid while /api/portal/status is in flight
  //   confirmed — the subscriber picked; show exactly what is coming
  //   chefs     — the subscriber did not pick; Chef's Choice is handling it
  //   unknown   — the status call failed; say nothing either way
  // Every write is compared before assigning, per the same idempotency rule
  // that assets/custom.js follows, because custom.js module [2] runs a
  // MutationObserver over document.body on this page.
  function tccRenderCutoffBanner_(state) {
    tccHideInteractive_();

    var banner = document.getElementById('tcc-cutoff-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'tcc-cutoff-banner';
      banner.className = 'tcc-success tcc-cutoff-banner';
      var progressSection = portal.querySelector('.tcc-progress-section');
      if (progressSection && progressSection.parentNode) {
        progressSection.parentNode.insertBefore(banner, progressSection);
      } else {
        portal.appendChild(banner);
      }
    }

    var reopen = 'Next week\'s menu opens <strong>Sunday 11PM</strong> — come back then to pick again.';
    var html;

    if (state.phase === 'confirmed') {
      var tags = (state.meals || []).map(function(n){ return '<span class="tcc-success__tag">&#10003; ' + n + '</span>'; });
      if (state.bonusDish) tags.push('<span class="tcc-success__tag">&#127873; Bonus: ' + state.bonusDish + '</span>');
      html =
        '<div class="tcc-success__icon">&#9989;</div>' +
        '<div class="tcc-success__content">' +
          '<strong>This weekend\'s order is locked in</strong>' +
          '<p>Picking closed Thursday 11PM. Here\'s what\'s coming this weekend. ' + reopen + '</p>' +
          '<div class="tcc-success__tags">' + tags.join('') + '</div>' +
          (state.customerNote ? '<p style="margin-top:8px;font-size:.76rem;color:#8A6A2A">&#128221; Your note: ' + state.customerNote.replace(/</g,'&lt;') + '</p>' : '') +
          tccSidesStateHtml_(state.sides) +
          '<div id="tcc-portal-push-nudge"></div>' +
        '</div>';
    } else if (state.phase === 'chefs') {
      html =
        '<div class="tcc-success__icon">&#128104;&#8205;&#127859;</div>' +
        '<div class="tcc-success__content">' +
          '<strong>Chef\'s Choice is on for this weekend</strong>' +
          '<p>Picking closed Thursday 11PM and we didn\'t get your selections, so we\'re hand-picking your dishes for this weekend\'s delivery. ' + reopen + '</p>' +
          '<div id="tcc-portal-push-nudge"></div>' +
        '</div>';
    } else if (state.phase === 'unknown') {
      html =
        '<div class="tcc-success__icon">&#9200;</div>' +
        '<div class="tcc-success__content">' +
          '<strong>Picking is closed for this weekend</strong>' +
          '<p>Picking closed Thursday 11PM. We couldn\'t load your selections just now — if you confirmed dishes, they\'re safe with us. ' + reopen + '</p>' +
        '</div>';
    } else {
      html =
        '<div class="tcc-success__icon">&#9200;</div>' +
        '<div class="tcc-success__content">' +
          '<strong>Picking is closed for this weekend</strong>' +
          '<p>Checking your order…</p>' +
        '</div>';
    }

    if (banner.innerHTML !== html) banner.innerHTML = html;
    if (state.phase === 'confirmed' || state.phase === 'chefs') tccMaybeShowPushNudge_('tcc-portal-push-nudge');
  }

  // v10: a second, better-timed prompt to enable push reminders — right
  // after a subscriber sees their confirmed dishes, rather than only the
  // passive top banner most people scroll past. Only shows if reminders
  // aren't already on, and quietly does nothing if push isn't supported
  // at all (older browsers) or the check itself fails — this is a nice-
  // to-have nudge, never something that should block or clutter the
  // success state.
  function tccMaybeShowPushNudge_(targetElId) {
    var target = document.getElementById(targetElId);
    if (!target) return;
    if (typeof tccIsIOS_ !== 'function') return; // tcc-push.js not loaded for some reason

    if (tccIsIOS_() && !tccIsStandalone_()) {
      target.innerHTML = '<button type="button" class="tcc-portal-push-nudge-btn" onclick="tccShowIOSInstallInstructions_()">\uD83D\uDCF2 Get a reminder next week \u2014 tap to enable</button>';
      return;
    }
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (Notification.permission === 'granted') return; // already enabled, nothing to nudge
    if (Notification.permission === 'denied') return; // respect an explicit past decline, don't nag

    target.innerHTML = '<button type="button" class="tcc-portal-push-nudge-btn" onclick="tccSubscribeToPush()">\uD83D\uDD14 Get a reminder before next week\'s cutoff</button>';
  }

  // --- COUNTDOWN ---
  // v12 (2026-08-11): TIMEZONE FIX. The v11 helper below was
  //     new Date(d.toLocaleString('en-US',{timeZone:'America/New_York'})).getTime() - d.getTime()
  // which does NOT return the Eastern offset. new Date(string) parses a date
  // string in the VISITOR'S OWN timezone, so the expression evaluates to
  // (Eastern - LOCAL). It is correct only when the browser happens to be set
  // to UTC. For an Eastern visitor it returns 0, the getUTC* calls below then
  // read genuine UTC fields, and the cutoff lands at 20:00 UTC — 4PM ET, four
  // hours early. Measured against live readings on Aug 11 2026 (3d 6h 49m at
  // 09:10 ET and 3d 3h 46m at ~12:13 ET, both extrapolating to Fri Aug 14
  // 4:00 PM ET). Every US visitor saw a wrong deadline, the error scaling with
  // distance from UTC (Pacific 1PM, Kolkata Sat 1:30 AM).
  //
  // The v11 header's claim that this worked "regardless of which timezone the
  // customer's device is configured for" was exactly inverted: it was correct
  // ONLY on a UTC device.
  //
  // Intl.DateTimeFormat.formatToParts reports America/New_York civil time
  // directly, with no dependency on the host zone and with EST/EDT handled
  // internally. tccEtWallClockToUTC_ resolves a wall-clock time back to an
  // instant in two passes, because the offset that applies depends on the very
  // instant being computed — one pass is wrong across a DST boundary (verified
  // against both 2026 transitions).
  var TCC_ET_FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  function tccEtParts_(d) {
    var p = {};
    TCC_ET_FMT.formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    var h = p.hour === '24' ? '0' : p.hour;   // some engines emit hourCycle h24
    return { year: +p.year, month: +p.month, day: +p.day,
             hour: +h, minute: +p.minute, second: +p.second };
  }
  function tccEasternOffsetMs_(d) {
    var p = tccEtParts_(d);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second)
         - Math.floor(d.getTime() / 1000) * 1000;
  }
  function tccEtWallClockToUTC_(y, mo1, da, hr) {
    var naive = Date.UTC(y, mo1 - 1, da, hr, 0, 0);
    var utc = naive - tccEasternOffsetMs_(new Date(naive));
    return naive - tccEasternOffsetMs_(new Date(utc));   // 2nd pass: DST-correct
  }
  function tccEtDow_(p) {
    return new Date(Date.UTC(p.year, p.month - 1, p.day)).getUTCDay();   // 0 = Sunday
  }
  function tccDaysUntilFri_(p) {
    var dow = tccEtDow_(p);
    var u = (4 - dow + 7) % 7;                    // Thursday = 4
    return (u === 0 && p.hour >= 23) ? 7 : u;     // already past 11PM ET
  }

  function nextFridayCutoff_() {
    var p = tccEtParts_(new Date());
    var t = new Date(Date.UTC(p.year, p.month - 1, p.day + tccDaysUntilFri_(p)));
    return new Date(tccEtWallClockToUTC_(
      t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate(), 23));
  }

  // v14: is picking closed right now? TRUE from Thursday 11PM ET through Sunday
  // 10:59:59PM ET. See the file header for why this window exists — the short
  // version is that the CURRENT menu has to stay live all Saturday for one-off
  // orders delivered Sunday, so the metaobjects can only be flipped at Saturday
  // midnight, and the portal must not show a grid it would file against the
  // wrong week. Recomputed on every tick rather than cached, so a page left
  // open across Sunday 11PM updates its countdown without a reload.
  function tccIsPickingLocked_() {
    var p = tccEtParts_(new Date());
    var dow = tccEtDow_(p);
    if (dow === 4 && p.hour >= 23) return true; if (dow === 5) return true;   // Thursday from 11PM ET, then all of Friday
    if (dow === 6) return true;                   // all of Saturday
    if (dow === 0 && p.hour < 23) return true;    // Sunday, until 11PM ET
    return false;
  }

  // v4: derives the SAME "Monday of the week" key the backend stores against.
  //
  // v14: THIS NOW ROLLS AT SUNDAY 11PM ET, NOT AT THE FRIDAY 8PM CUTOFF.
  // Those are two different instants and treating them as one was the bug.
  // Between Friday 8PM and Sunday 11PM the key deliberately keeps pointing at
  // the weekend being DELIVERED, so /api/portal/status returns the picks that
  // actually apply and the locked card above shows the right dishes. Nothing
  // is written during that window because tccIsPickingLocked_() is true and
  // both the UI and tccConfirm() are gated on it.
  //
  // THIS MUST STAY EQUIVALENT TO weekOfMonday() IN assets/custom.js.
  // /api/portal/status takes week_of straight off the query string and never
  // recomputes it, and PortalConfirmations rows carry whatever THIS function
  // sent. If the two drift, custom.js module [2] queries a week this file
  // never wrote and shows false "no order" alerts to healthy subscribers.
  // Note the two formulas agree everywhere OUTSIDE the locked window, so a
  // mismatch is invisible Monday to Friday and only shows up at the weekend.
  // Do NOT align either one to the Worker's getWeekOfMonday(): that is a plain
  // calendar-week Monday with no rollover — right for server-side jobs, wrong
  // here.
  function tccWeekOfMonday_() {
    var p = tccEtParts_(new Date());
    var dow = tccEtDow_(p);
    var offset = -((dow + 6) % 7);                  // back to this week's Monday
    if (dow === 0 && p.hour >= 23) offset = 1;      // Sun 11PM ET: next week opens
    var mon = new Date(Date.UTC(p.year, p.month - 1, p.day + offset));
    return mon.getUTCFullYear() + '-' + String(mon.getUTCMonth() + 1).padStart(2, '0') + '-' + String(mon.getUTCDate()).padStart(2, '0');
  }

  var TCC_PICKING_LOCKED = tccIsPickingLocked_();

  tccCheckExistingConfirmation_();

  // v11: FIXED a race condition — this previously called tccIsStandalone_()
  // (defined in the separate assets/tcc-push.js) to decide whether to
  // attach the fade listener at all. Depending on script load order,
  // tcc-push.js isn't guaranteed to have finished loading by the time
  // this snippet's own script runs, so the guard could silently skip
  // attaching the fade listener entirely — confirmed on desktop Chrome:
  // the Install button correctly flipped to "App Installed" (that logic
  // lives inside tcc-push.js itself, unaffected), but the banner never
  // faded, because ITS listener was never registered in the first place.
  // Fix: duplicate the two-line standalone check locally (no dependency
  // on tcc-push.js having loaded yet) and always attach the appinstalled
  // listener unconditionally — attaching a listener is always safe
  // regardless of load order, unlike calling a function that might not
  // exist yet.
  function tccPortalIsStandalone_() {
    return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
  }
  function tccInitInstallBanner_() {
    var banner = document.getElementById('tcc-portal-install-banner');
    if (!banner) return;
    if (tccPortalIsStandalone_()) { banner.style.display = 'none'; return; }
    window.addEventListener('appinstalled', function() {
      banner.classList.add('tcc-install-banner--fade');
      setTimeout(function() { banner.style.display = 'none'; }, 450);
    });
  }
  tccInitInstallBanner_();

  function tickCountdown() {
    var el = document.getElementById('tcc-cd-top');
    if (!el) return;
    if (tccIsPickingLocked_()) {
      var closed = 'Picking reopens Sunday 11PM';
      if (el.textContent !== closed) el.textContent = closed;
      return;
    }
    var diff = nextFridayCutoff_() - new Date();
    if (diff <= 0) { el.textContent = 'Deadline passed'; return; }
    var d = Math.floor(diff / 86400000),
        h = Math.floor((diff % 86400000) / 3600000),
        m = Math.floor((diff % 3600000) / 60000);
    el.textContent = d + 'd ' + h + 'h ' + m + 'm left';
  }
  tickCountdown();
  setInterval(tickCountdown, 30000);

  function tickManageDeadline() {
    var el = document.getElementById('tcc-manage-deadline-text');
    var wrap = document.getElementById('tcc-manage-deadline');
    if (!el || !wrap) return;
    // v14: inside the locked window nextFridayCutoff_() already points at NEXT
    // Friday, so the normal branch would cheerfully report six days left to
    // skip "this week's" delivery while this week's delivery is being loaded
    // into the van. Say the true thing instead.
    if (tccIsPickingLocked_()) {
      wrap.classList.add('tcc-manage-deadline--closed');
      var closed = "This weekend's cutoff has passed — skip/pause now applies to next week's delivery.";
      if (el.textContent !== closed) el.textContent = closed;
      return;
    }
    var diff = nextFridayCutoff_() - new Date();
    if (diff <= 0) {
      wrap.classList.add('tcc-manage-deadline--closed');
      el.textContent = "This week's cutoff has passed — skip/pause now will apply to next week's order.";
      return;
    }
    wrap.classList.remove('tcc-manage-deadline--closed');
    var d = Math.floor(diff / 86400000),
        h = Math.floor((diff % 86400000) / 3600000),
        m = Math.floor((diff % 3600000) / 60000);
    el.textContent = 'You have ' + d + 'd ' + h + 'h ' + m + 'm left to skip/pause/cancel for this week\'s delivery.';
  }
  tickManageDeadline();
  setInterval(tickManageDeadline, 30000);

  // --- FILTER ---
  window.tccFilter = function(type, btn) {
    document.querySelectorAll('.tcc-filter').forEach(function(b) { b.classList.remove('tcc-filter--on'); });
    btn.classList.add('tcc-filter--on');
    document.querySelectorAll('.tcc-dish').forEach(function(card) {
      card[type === 'all' || card.dataset.type === type ? 'removeAttribute' : 'setAttribute']('hidden', '');
    });
  };

  // --- DISH QTY ---
  function totalQty() {
    var t = 0; selected.forEach(function(q){ t += q; }); return t;
  }

  function shake(el) {
    el.animate([{transform:'translateX(0)'},{transform:'translateX(-6px)'},{transform:'translateX(6px)'},{transform:'translateX(0)'}],{duration:320});
  }

  function setQty(card, qty) {
    var h = card.dataset.handle;
    if (qty <= 0) { selected.delete(h); card.classList.remove('tcc-dish--on'); }
    else { selected.set(h, qty); card.classList.add('tcc-dish--on'); }
    var qtyWrap = card.querySelector('.tcc-dish__qty');
    qtyWrap.dataset.qty = qty;
    qtyWrap.querySelector('.tcc-qty-num').textContent = qty;
    card.setAttribute('aria-label', card.dataset.name + ', quantity ' + qty);
    updateUI();
  }

  window.tccAddOne = function(card) {
    var current = selected.get(card.dataset.handle) || 0;
    if (totalQty() >= MAX) { shake(card); return; }
    setQty(card, current + 1);
  };

  window.tccRemoveOne = function(card) {
    var current = selected.get(card.dataset.handle) || 0;
    if (current <= 0) return;
    setQty(card, current - 1);
  };

  document.querySelectorAll('.tcc-dish').forEach(function(card) {
    card.addEventListener('click', function(e) { if (!e.target.closest('.tcc-qty-btn')) tccAddOne(card); });
    card.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tccAddOne(card); } });
    card.querySelector('.tcc-qty-btn--plus').addEventListener('click', function(e) { e.stopPropagation(); tccAddOne(card); });
    card.querySelector('.tcc-qty-btn--minus').addEventListener('click', function(e) { e.stopPropagation(); tccRemoveOne(card); });
  });

  // --- SIDES ---
  document.querySelectorAll('.tcc-side-card').forEach(function(card) {
    var variantWrap = card.querySelector('.tcc-side-card__variants');
    var qtyWrap = card.querySelector('.tcc-side-card__qty');
    if (variantWrap) {
      var pills = variantWrap.querySelectorAll('.tcc-side-variant-pill');
      pills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          var oldId = qtyWrap.dataset.activeVariantId;
          var oldQty = parseInt(qtyWrap.dataset.qty, 10) || 0;
          if (oldQty > 0) selectedSides.delete(oldId);
          pills.forEach(function(p){ p.classList.remove('tcc-side-variant-pill--on'); });
          pill.classList.add('tcc-side-variant-pill--on');
          qtyWrap.dataset.activeVariantId = pill.dataset.variantId;
          var pd = card.querySelector('[data-price-display]');
          if (pd) pd.innerHTML = '$' + pill.dataset.price + ' <span>/ each</span>';
          if (oldQty > 0) selectedSides.set(pill.dataset.variantId, { qty: oldQty, title: card.querySelector('.tcc-side-card__name').textContent + ' (' + pill.dataset.variantTitle + ')', price: pill.dataset.price });
          updateSidesUI();
        });
      });
    }
  });

  document.querySelectorAll('.tcc-side-card__qty').forEach(function(qtyWrap) {
    var card = qtyWrap.closest('.tcc-side-card');
    function getVariantInfo() {
      var vw = card.querySelector('.tcc-side-card__variants');
      if (vw) {
        var ap = vw.querySelector('.tcc-side-variant-pill--on');
        return { variantId: qtyWrap.dataset.activeVariantId, title: card.querySelector('.tcc-side-card__name').textContent + (ap ? ' (' + ap.dataset.variantTitle + ')' : ''), price: ap ? ap.dataset.price : '0' };
      }
      var pe = card.querySelector('.tcc-side-card__price');
      return { variantId: qtyWrap.dataset.activeVariantId, title: card.querySelector('.tcc-side-card__name').textContent, price: pe ? pe.textContent.replace(/[^0-9.]/g,'') : '0' };
    }
    function setSideQty(qty) {
      var info = getVariantInfo();
      qty = Math.max(0, qty);
      qtyWrap.dataset.qty = qty;
      qtyWrap.querySelector('.tcc-qty-num').textContent = qty;
      if (qty <= 0) selectedSides.delete(info.variantId);
      else selectedSides.set(info.variantId, { qty: qty, title: info.title, price: info.price });
      updateSidesUI();
    }
    qtyWrap.querySelector('.tcc-qty-btn--plus').addEventListener('click', function(){ setSideQty((parseInt(qtyWrap.dataset.qty,10)||0)+1); });
    qtyWrap.querySelector('.tcc-qty-btn--minus').addEventListener('click', function(){ setSideQty((parseInt(qtyWrap.dataset.qty,10)||0)-1); });
  });

  function updateSidesUI() {
    var noteEl = document.getElementById('tcc-sides-total');
    if (!noteEl) return;
    if (!selectedSides.size) { noteEl.hidden = true; return; }
    var ti = 0, tp = 0;
    selectedSides.forEach(function(s){ ti += s.qty; tp += s.qty * parseFloat(s.price||0); });
    noteEl.hidden = false;
    noteEl.innerHTML = ti + ' side' + (ti===1?'':'s') + ' added &middot; $' + tp.toFixed(2);
  }

  function updateUI() {
    var n = totalQty();
    document.getElementById('tcc-sel-n').textContent = n;
    document.getElementById('tcc-fill').style.width = (n / MAX * 100) + '%';
    var atMax = n >= MAX;
    document.querySelectorAll('.tcc-dish').forEach(function(c) {
      c.classList.toggle('tcc-dish--dim', atMax && !selected.has(c.dataset.handle));
      var pb = c.querySelector('.tcc-qty-btn--plus');
      if (pb) pb.disabled = atMax;
    });
    var btn = document.getElementById('tcc-confirm-btn');
    var note = document.getElementById('tcc-confirm-note');
    btn.disabled = n === 0;
    note.textContent = n === 0 ? ('Select ' + MAX + ' dishes to confirm') : (n === MAX ? ('All ' + MAX + ' dishes selected!') : ((MAX - n) + ' more to go'));
  }

  // --- CONFIRM ---
  window.tccConfirm = function() {
    if (!selected.size) return;
    // v14: last line of defence. The interactive area is hidden inside the
    // locked window, but this is a global function reachable from the console
    // and from a page left open across Friday 8PM, and a write here would be
    // filed against a week whose cutoff has already passed.
    if (tccIsPickingLocked_()) return;
    var names = [];
    selected.forEach(function(qty, h) {
      var c = document.querySelector('[data-handle="' + h + '"]');
      if (!c) return;
      for (var i = 0; i < qty; i++) names.push(c.dataset.name);
    });
    var bonusDish = '';
    if (IS_SUBSCRIBER) {
      var bs = document.getElementById('tcc-bonus-select');
      bonusDish = bs ? bs.value : '';
    }
    var btn = document.getElementById('tcc-confirm-btn');
    var note = document.getElementById('tcc-confirm-note');
    btn.textContent = 'Saving...'; btn.disabled = true;
    // v4.1: clear any leftover error styling/text from a previous failed attempt
    if (note) { note.style.color = ''; }

    var sideItems = [], sideNames = [];
    selectedSides.forEach(function(info, vid) { sideItems.push({ variantId: vid, quantity: info.qty, title: info.title }); sideNames.push(info.title + ' x' + info.qty); });

    // v4.1: read Shopify's own error body when a cart call fails (it
    // usually explains exactly why — sold out, invalid quantity, etc.)
    // instead of throwing a blank, undiagnosable Error.
    function tccCheckCartResponse_(r, fallbackLabel) {
      if (r.ok) return r.json();
      return r.json().catch(function(){ return {}; }).then(function(body) {
        throw new Error(body.description || (fallbackLabel + ' failed (HTTP ' + r.status + ')'));
      });
    }

    var weekOf = tccWeekOfMonday_();
    var attrs = { meal_selections: names.join(' | '), selection_week: new Date().toISOString().slice(0,10), chefs_choice_fallback: document.getElementById('tcc-chefs').checked ? 'Yes' : 'No' };
    if (bonusDish) attrs['bonus_dish_selection'] = bonusDish;
    if (sideNames.length) attrs['sides_selected'] = sideNames.join(' | ');

    // v6: this whole flow now only ever runs for subscribers (the
    // non-subscriber path no longer renders the interactive portal at
    // all), so this call always fires when Confirm is reachable.
    var confirmDishesPromise = fetch(WORKER_URL + '/api/confirm-dishes', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            email: portal.dataset.customerEmail,
            week_of: weekOf,
            meals: names,
            bonus_dish: bonusDish,
            customer_note: (function(){
              var el = document.getElementById('tcc-customer-note');
              return el ? el.value.trim().slice(0, 500) : '';
            })()
          })
        })
        .then(function(r){ if (!r.ok) throw new Error('Saving your dishes failed (HTTP ' + r.status + ') — please try again'); return r.json(); })
        .then(function(res){ if (res.status !== 'ok') throw new Error(res.message || 'Saving your dishes failed — please try again'); });

    // v17: sides used to go through /cart/add.js + a separate /checkout
    // redirect, which created a brand new standalone order — a second,
    // misleading order that also charged a second delivery fee for
    // what's really just an add-on to an already-paid delivery. Sides
    // now go straight to the Worker, which edits the customer's
    // EXISTING subscription order directly via Shopify's Order Editing
    // API and automatically emails an invoice for just the new balance
    // — no second order, no second delivery fee, no checkout redirect.
    // This runs AFTER dishes are confirmed, and a sides failure here
    // does not block the dish confirmation from succeeding — it's
    // caught separately below so the customer still sees their dishes
    // confirmed either way.
    function requestSidesIfAny_() {
      if (!sideItems.length) return Promise.resolve({ requested: false });
      return fetch(WORKER_URL + '/api/request-sides', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ email: portal.dataset.customerEmail, customer_id: portal.dataset.customerId, week_of: weekOf, items: sideItems })
      })
        .then(function(r){ return r.json(); })
        .then(function(res) {
          return { requested: true, ok: res.status === 'ok', pay_url: res.pay_url || '', total: res.total || '', items: res.items || [], message: res.message || '' };
        })
        .catch(function(err) {
          return { requested: true, ok: false, applied: false, message: err.message || 'Network error adding sides.' };
        });
    }

    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:'Meal selections: '+names.join(', ')+(bonusDish?' | Bonus: '+bonusDish:'')+(sideNames.length?' | Sides: '+sideNames.join(', '):''),attributes:attrs})})
      .then(function(r){ return tccCheckCartResponse_(r, 'Saving your cart'); })
      .then(function(){ return confirmDishesPromise; })
      .then(function(){ return requestSidesIfAny_(); })
      .then(function(sidesResult){
        document.querySelector('.tcc-confirm-row').style.display='none';
        var suc=document.getElementById('tcc-success');
        suc.removeAttribute('hidden');
        var tags=names.map(function(n){return '<span class="tcc-success__tag">&#10003; '+n+'</span>';});
        if(bonusDish) tags.push('<span class="tcc-success__tag" style="border-color:#C9A24B;color:#8B5E10;">&#127873; Bonus: '+bonusDish+'</span>');
        document.getElementById('tcc-success-tags').innerHTML=tags.join('');
        tccMaybeShowPushNudge_('tcc-portal-push-nudge');

        var contentEl = suc.querySelector('.tcc-success__content p');
        if (sidesResult.requested) {
          if (sidesResult.ok && sidesResult.pay_url) {
            // v15: dishes are saved; sides need one tap to pay. The pay card
            // is the only thing left to do, so it goes right under the dishes.
            if (contentEl) contentEl.textContent = "Your dishes are confirmed. There's one quick step left for your sides below.";
            var payWrap = document.createElement('div');
            payWrap.innerHTML = tccSidesStateHtml_({ status: 'Awaiting Payment', pay_url: sidesResult.pay_url, total: sidesResult.total, items: sidesResult.items });
            var tagsEl = document.getElementById('tcc-success-tags');
            if (tagsEl && tagsEl.parentNode) tagsEl.parentNode.insertBefore(payWrap.firstChild, tagsEl.nextSibling);
          } else if (contentEl) {
            contentEl.textContent = 'Your dishes are confirmed! ' + (sidesResult.message || "We couldn't set up payment for your sides — please WhatsApp us and we'll take care of it.");
          }
        }
        suc.scrollIntoView({behavior:'smooth',block:'nearest'});
      })
      .catch(function(err){
        // v4.1: surface WHY it failed instead of a silent generic
        // "Try again" — console for you/debugging, on-page note for
        // the customer so they know whether to just retry or fix
        // something (e.g. remove a sold-out side) first.
        console.error('TCC portal confirm failed:', err);
        btn.textContent = 'Try again';
        btn.disabled = false;
        if (note) {
          note.textContent = (err && err.message ? err.message : 'Something went wrong saving your order — please try again.');
          note.style.color = '#C0392B';
        }
      });
  };


  // --- PLAN CHANGE: WhatsApp request ---
  var planPills = document.querySelectorAll('.tcc-plan-pill');
  var planBtn = document.getElementById('tcc-plan-change-btn');
  var planHint = document.getElementById('tcc-plan-change-hint');
  var planConfirm = document.getElementById('tcc-plan-change-confirm');
  var currentPlanName = portal.dataset.planName;
  var currentPlanMeals = portal.dataset.planMeals;
  var firstName = portal.dataset.firstName;
  var selectedPlanName = '';
  var selectedPlanMeals = '';

  planPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      planPills.forEach(function(p){ p.classList.remove('tcc-plan-pill--on'); });
      pill.classList.add('tcc-plan-pill--on');
      selectedPlanName = pill.dataset.plan;
      selectedPlanMeals = pill.dataset.meals;
      // Activate the button
      planBtn.classList.add('tcc-plan-change-btn--ready');
      planBtn.textContent = '\uD83D\uDCAC Request Switch to ' + selectedPlanName + ' (' + selectedPlanMeals + ' meals/wk)';
      if (planHint) planHint.style.display = 'none';
    });
  });

  if (planBtn) {
    planBtn.addEventListener('click', function() {
      if (!selectedPlanName) return;
      var msg = 'Hi, this is ' + firstName + '. I would like to change my meal plan.\n\nCurrent plan: ' + currentPlanName + ' (' + currentPlanMeals + ' meals/week)\nNew plan: ' + selectedPlanName + ' (' + selectedPlanMeals + ' meals/week)\n\nCould you please handle this for me? Thank you!';
      // Show confirmation banner first
      if (planConfirm) planConfirm.style.display = 'flex';
      // Open WhatsApp after short delay so banner renders
      setTimeout(function() {
        window.open('https://wa.me/18482268666?text=' + encodeURIComponent(msg), '_blank');
      }, 200);
      // Disable button to prevent double-send
      planBtn.textContent = '\u2705 Request sent!';
      planBtn.style.background = '#1A5C3A';
      planBtn.style.pointerEvents = 'none';
    });
  }

  // --- WEEKLY SIDES: WhatsApp request (v16) ---
  (function() {
    var box = document.getElementById('tcc-weekly-sides-box');
    if (!box) return;
    var btn = document.getElementById('tcc-weekly-sides-btn');
    var hint = document.getElementById('tcc-weekly-sides-hint');
    var confirmEl = document.getElementById('tcc-weekly-sides-confirm');
    var removeLink = document.getElementById('tcc-weekly-sides-remove');
    var rows = box.querySelectorAll('.tcc-weekly-side');
    function picks() {
      var out = [];
      rows.forEach(function(r) {
        var q = parseInt(r.querySelector('.tcc-weekly-side__qty').dataset.qty, 10) || 0;
        if (q > 0) out.push({ title: r.dataset.title, qty: q, price: parseFloat(r.dataset.price) || 0 });
      });
      return out;
    }
    function refresh() {
      var p = picks();
      var total = p.reduce(function(s, x) { return s + x.qty * x.price; }, 0);
      btn.classList.toggle('tcc-plan-change-btn--ready', p.length > 0);
      btn.textContent = p.length ? '\uD83D\uDCAC Request weekly sides \u2014 about $' + total.toFixed(2) + '/week extra' : '\uD83D\uDCAC Request weekly sides via WhatsApp';
    }
    rows.forEach(function(r) {
      var qw = r.querySelector('.tcc-weekly-side__qty');
      var num = qw.querySelector('.tcc-qty-num');
      function set(q) { q = Math.max(0, Math.min(20, q)); qw.dataset.qty = q; num.textContent = q; refresh(); }
      qw.querySelector('.tcc-qty-btn--plus').addEventListener('click', function() { set((parseInt(qw.dataset.qty, 10) || 0) + 1); });
      qw.querySelector('.tcc-qty-btn--minus').addEventListener('click', function() { set((parseInt(qw.dataset.qty, 10) || 0) - 1); });
    });
    function send(msg) {
      if (confirmEl) confirmEl.style.display = 'flex';
      setTimeout(function() { window.open('https://wa.me/18482268666?text=' + encodeURIComponent(msg), '_blank'); }, 200);
      btn.textContent = '\u2705 Request sent!';
      btn.style.background = '#1A5C3A';
      btn.style.pointerEvents = 'none';
      if (hint) hint.style.display = 'none';
    }
    btn.addEventListener('click', function() {
      var p = picks();
      if (!p.length) return;
      var lines = p.map(function(x) { return '\u2022 ' + x.title + ' \u00d7 ' + x.qty + ' every week'; }).join('\n');
      var total = p.reduce(function(s, x) { return s + x.qty * x.price; }, 0);
      send('Hi, this is ' + firstName + '. Please add these sides to my weekly subscription (' + currentPlanName + ', ' + currentPlanMeals + ' meals/week):\n\n' + lines + '\n\nThat\u2019s about $' + total.toFixed(2) + ' extra per week. Please confirm my new weekly total. Thank you!');
    });
    if (removeLink) removeLink.addEventListener('click', function(e) {
      e.preventDefault();
      send('Hi, this is ' + firstName + '. I\u2019d like to change or remove the weekly sides on my subscription (' + currentPlanName + ', ' + currentPlanMeals + ' meals/week). New weekly sides should be: ');
    });
  })();

  var tccNoteEl = document.getElementById('tcc-customer-note');
  var tccNoteN = document.getElementById('tcc-note-n');
  if (tccNoteEl && tccNoteN) {
    tccNoteEl.addEventListener('input', function(){ tccNoteN.textContent = tccNoteEl.value.length; });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
